import { render, staticRenderFns } from "./OwalTransitionFade.vue?vue&type=template&id=5461f6a5&scoped=true"
import script from "./OwalTransitionFade.vue?vue&type=script&lang=js"
export * from "./OwalTransitionFade.vue?vue&type=script&lang=js"
import style0 from "./OwalTransitionFade.vue?vue&type=style&index=0&id=5461f6a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5461f6a5",
  null
  
)

export default component.exports